import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { MyWorkshopFrameComponent }    from './my-workshop.frame.component';
import { MyWorkshopService }           from './my-workshop.service';
import { MyWorkshopSettingsComponent } from './my-workshop.settings.component';
import { MyWorkshopStates }            from './my-workshop.states';
import { SharedModule }                from '../shared/shared.module';

@NgModule({
  declarations: [
    MyWorkshopFrameComponent,
    MyWorkshopSettingsComponent
  ],
  entryComponents: [
    MyWorkshopSettingsComponent
  ],
  exports: [
    MyWorkshopSettingsComponent
  ],
  imports: [
    SharedModule,
    UIRouterUpgradeModule.forChild({ states: MyWorkshopStates })
  ],
  providers: [
    MyWorkshopService
  ]
})
export class MyWorkshopModule {}
